import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { UpiPaymentApi  } from '../api/UpiPaymentMst.api';
import { switchMap, map } from 'rxjs/operators';

import {UpiPaymentMst,UpiPaymentMstData  } from '../../../interfaces/masters/UpiPaymentMst' ;
@Injectable()
export class UpiPaymentMstService extends UpiPaymentMstData {

    constructor(private api: UpiPaymentApi) {
      super();
    }
  
  
    list(): Observable<UpiPaymentMst[]> {
      return this.api.list();
    }
  
    getById(url:string): Observable<UpiPaymentMst>{
        return this.api.getById(url);
    }
  
    create(url: string, data:UpiPaymentMst): Observable<UpiPaymentMst[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:UpiPaymentMst): Observable<UpiPaymentMst[]> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  